import {Stack} from '@mui/material';
import {FC} from 'react';
import {Header} from '../header';
import {FieldGroups} from '../field-groups';

export const StepForm: FC = () => {
  return (
    <Stack gap="30px">
      <Header />
      <FieldGroups />
    </Stack>
  );
};
